import React from 'react';
import { TabView } from '../TabView';
import Community from './Community';
import FeaturedAmenities from './FeaturedAmenities';
import InUnit from './InUnit';
import PropertyServices from './PropertyServices';

const Amenities = () => {
  return (
    <TabView>
      <FeaturedAmenities />
      <Community />
      <InUnit />
      <PropertyServices />
    </TabView>
  );
};

export default Amenities;
